export default __webpack_public_path__ + "static/media/large-luggage.cb4424ca.svg";